import { useDispatch, useSelector } from 'react-redux'
import { RaytebRequests } from '../../_services'
import useFetch from '../../_services/fetch'
import { TextBoxTypeEnum } from '../../enums/TextBoxTypeEnum'
import {
  CollapseImageGroup,
  LoadingFit,
  PageHeader,
  ZipPatientRecordModal,
} from '../../share/Components'
import {
  Button,
  DatePicker,
  Icon,
  RaytebForm,
  Table,
  TextBox,
} from '../../share/Elements'
import HelTag from 'react-helmet'
import { ReducerType } from '../../storeManager/ReducerType'
import { LoginInterface } from '../../Interfaces/LoginInterface'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PrescriptionViewModel } from '../../models/ViewModels/PrescriptionViewModel'
import { addOrUpdatePrescription } from '../../storeManager/Reducers/prescriptionSlice'
import {
  PatientListViewModel,
  RecordType,
} from '../../models/ViewModels/PatientListViewModel'
import { CollapseImageInterface } from '../../Interfaces/CollapseInterface'
import { PersonInterface } from '../../Interfaces/PersonInterface'

type PaginationTicket = {
  patientCode?: string
  take?: number | undefined
}
type Dates = {
  fromDate: string
  toDate: string
}
const Patient = () => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const [list, setList] = useState<Array<PatientListViewModel>>([])

  const getAll = useFetch<Array<PatientListViewModel>, PatientListInputModel>({
    request: RaytebRequests.Patient_List_POST({
      token: user.token,
      centerId: center.id,
    }),
    onSuccess(data) {
      setList([...list, ...data])
    },
  })

  const [date, setDate] = useState<Dates>({
    fromDate: new Date().toISOString(),
    toDate: new Date().toISOString(),
  })
  const navigation = useNavigate()
  const dispatch = useDispatch()

  const [pagingTicket, setPagingTicket] = useState<Array<PaginationTicket>>([])
  const initialPaging = 8
  const elementTicket = (key, patient: PersonInterface, record: RecordType) => (
    <div
      key={key}
      className='w-full h-full float-left text-xs
       bg-primaryDefault2 font-bold py-2'
    >
      <span className='float-right pr-12'>{new Date(record.insertDate).toShamsi()}</span>
      <div className='h-full float-left pl-20'>
        <Icon
          disabled={!record.hasItems}
          icon='rayteb-printer'
          onClick={() => {
            window.open(
              `${window.env['APP_Domain']}/api/DoctorProfile/Patient/PrintPatientProfileWithPrescription?centerId=${center.id}&doctorCode=${user.userData?.code}&patientCode=${patient.code}&insertDate=${record.insertDate}`)
          }}
          className='text-xl text-primary'
        />
      </div>
    </div>
  )
  useEffect(() => {
    setList([])
    getAll.reFetch({
      fromDate: new Date(date.fromDate),
      toDate: new Date(date.toDate),
    })
  }, [center])
  return (
    <>
      <HelTag>
        <title>بیماران</title>
      </HelTag>
      <LoadingFit isLoading={getAll.isLoading} fixed={true} />
      <PageHeader title='بیماران' />
      <br />
      <RaytebForm
        checkIsRequired={true}
        onSubmit={(e) => {
          setDate({
            toDate: e.target['toDate'].getAttribute('rayteb-value'),
            fromDate: e.target['fromDate'].getAttribute('rayteb-value'),
          })
          getAll.reFetch({
            fromDate: e.target['fromDate'].getAttribute('rayteb-value'),
            toDate: e.target['toDate'].getAttribute('rayteb-value'),
            fullName: e.target['fullName'].value,
            patientCode: e.target['personCode'].value,
          })
        }}
        className='flex justify-center items-center flex-col'
      >
        <div className='flex px-3 md:w-[50%]'>
          <div className='flex justify-center items-center gap-x-2 px-2 w-full'>
            <DatePicker
              raytebValue={date.fromDate}
              value={new Date(date.fromDate).toShamsi()}
              name='fromDate'
              innerText='از تاریخ'
              className='w-full h-9'
              isRequired={true}
              onChange={(e) => {
                setList([])
                document.getElementById('submitForm')?.click()
              }}
            />
            <DatePicker
              name='toDate'
              raytebValue={date.toDate}
              value={new Date(date.toDate).toShamsi()}
              onChange={(e) => {
                setList([])
                document.getElementById('submitForm')?.click()
              }}
              innerText='تا تاریخ'
              className='w-full h-9'
              isRequired={true}
            />
          </div>
        </div>

        <div className='flex px-3 mt-5 md:w-[50%]'>
          <div className='flex justify-center items-center gap-x-2 px-2 w-full'>
            <TextBox
              name='fullName'
              innerText='نام و نام خانوادگی'
              className='w-full h-9'
              Type={TextBoxTypeEnum.Text}
              onChange={() => document.getElementById('submitForm')?.click()}
            />
            <TextBox
              name='personCode'
              innerText='کد ملی'
              onChange={() => document.getElementById('submitForm')?.click()}
              className='w-full h-9'
              Type={TextBoxTypeEnum.Number}
            />
          </div>
        </div>
        <input type='submit' id='submitForm' className='hidden' />
      </RaytebForm>

      <ZipPatientRecordModal />
      <CollapseImageGroup
        className='mt-2'
        items={getAll.result?.map(function (n, index): CollapseImageInterface {
          return {
            isShow: true,
            title: (
              <>
                <span className='text-primary'>{`${n.patient.firstName} ${n.patient.lastName}`}</span>
                <br />
                <span className='text-[11px] text-primaryLight font-bold'>
                  {n.patient.code}
                </span>
              </>
            ),
            url: n.patient.imageUrl,
            element: (
              <>
                <div className='flex justify-between mx-4 mt-2 mb-1 border-b border-y-primaryLight'>
                  <span>نمایش کل پرونده:</span>
                  <Icon
                    icon='rayteb-printer  !text-xl text-primaryLight cruser-pointer'
                    onClick={() => {
                      window.open(
                        `${window.env['APP_Domain']}/api/DoctorProfile/Patient/GetAllProfiles?centerId=${center.id}&doctorCode=${user.userData?.code}&patientCode=${n.patient.code}`
                      )
                    }}
                    className='text-xl text-primary'
                  />
                </div>
                {n.records.map((x, i) =>
                  i <
                    (pagingTicket.find((d) => d.patientCode === n.patient.code)
                      ?.take || initialPaging)
                    ? elementTicket(i, n.patient, x)
                    : ''
                )}
                {(pagingTicket.find((d) => d.patientCode === n.patient.code)
                  ?.take || initialPaging) < n.records.length ? (
                  <Button
                    className='mx-auto bg-primaryLight rounded-b-full w-32 my-2 text-white'
                    onClick={() => {
                      const ticket = pagingTicket.find(
                        (d) => d.patientCode === n.patient.code
                      )
                      if (!ticket)
                        setPagingTicket([
                          ...pagingTicket,
                          {
                            patientCode: n.patient.code,
                            take: initialPaging * 2,
                          },
                        ])
                      else {
                        const pagTickets = [...pagingTicket]
                        const indexT = pagingTicket.findIndex(
                          (a) => a.patientCode === n.patient.code
                        )
                        pagTickets[indexT].take = pagTickets[indexT].take! * 2
                        setPagingTicket(pagTickets)
                      }
                    }}
                  >
                    بیشتر
                  </Button>
                ) : (
                  ''
                )}
              </>
            ),
          }
        })}
      />
    </>
  )
}

export default Patient
